var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJourney24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    strokeLinejoin: "round",
    d: "m5.78 14.61 1.23-4.6c.08-.3.27-.55.54-.69.52-.28.73-.95.47-1.5-.43-.92-.36-2.46.35-3.22a1.8 1.8 0 0 1 1.87-.52l8.38 2.57M5.78 14.6l-.41-.15c-.9-.32-1.89.17-2.24 1.12-.39 1.04.13 2.22 1.13 2.55l7.6 2.65M5.78 14.6l6.52 2.1c.1.03.11.17.03.23a2.63 2.63 0 0 0-.74 3.33l.27.51m6.76-14.13-1.28 4.34m1.28-4.34c1.31.35 2.65.99 2.33 2.67-.36 1.92-1.83 2.33-3.61 1.67m-5.48 9.79c.68.35 1.59.23 2.01 0 .44-.24.78-.66.93-1.16l2.54-8.63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJourney24);
export default __webpack_public_path__ + "static/media/journey_24.1e005527dec3f47ffa202546ec217163.svg";
export { ForwardRef as ReactComponent };